import { Redirect, Route, Switch } from "react-router-dom"
import LibraryContainer from "components/containers/library/LibraryContainer"
import ReadArticleContainer from "components/containers/library/ReadArticleContainer"
import React from "react"
import { FeatureGate } from "utils/FeatureGate"

const LibraryRouter = () => {
  return (
    <>
      <Switch>
        <Redirect
          exact
          path="/read/Fertility-basics/Introducing-the-Ava-Bracelet"
          to="/your-benefit-guide/coverage/ava-bracelet"
        />
        <Route exact path="/read/:category?" component={LibraryContainer} />
        <Route exact path="/read/:category/:article" component={ReadArticleContainer} />
        <Redirect to={`/read`} />
      </Switch>
    </>
  )
}

export { LibraryRouter }
